import { useAddItemsToLibrary } from '@app/web-player/library/requests/use-add-items-to-library.ts';
import { useRemoveItemsFromLibrary } from '@app/web-player/library/requests/use-remove-items-from-library.ts';

import { useLibraryStore } from '@app/web-player/library/state/likes-store.ts';

export const useTagFollow = (id: number) => {
    const addToLibrary = useAddItemsToLibrary()
    const removeFromLibrary = useRemoveItemsFromLibrary()

    // @ts-ignore
    const isLiked = useLibraryStore(s => s.has({ id, model_type: 'tag' }))
    const isLoading = addToLibrary.isPending || removeFromLibrary.isPending

    return {
        isLiked,
        isLoading,
        toggleLike: () => {
            if (isLiked) {
                // @ts-ignore
                removeFromLibrary.mutate({ likeables: [{ id, model_type: 'tag' }] })
            } else {
                // @ts-ignore
                addToLibrary.mutate({likeables: [{ id, model_type: 'tag' }]})
            }
        }
    }
}
